const buttonCompCalendar = {
  filter: 'filters'
};

export default buttonCompCalendar;
